import React from 'react';
import {Navigate} from "react-router-dom";
import {checkToken} from "../apiClient/apiClient";

const RouteGuard = ({children, userState}) => {
    if (!checkToken(userState.token_refresh)) {
        return <Navigate to="/login"/>;
    }
    return children;
}
export default RouteGuard;
